import { LIMITS, type PartnerPage } from './types';

export interface Form {
  name: string;
  text: string;
  link: string;
  callToAction: string;
  logoId: string | null;
  logoPreview: string | null;
}

export function toForm(page: PartnerPage | null, fallbackName: string): Form {
  return {
    name: page?.name ?? fallbackName,
    text: page?.text ?? '',
    link: page?.link ?? '',
    callToAction: page?.callToAction ?? '',
    logoId: page?.logoId ?? null,
    logoPreview: page?.logoUrl ?? null,
  };
}

export function validatePartnerForm(form: Form): Partial<Record<keyof Form, string>> {
  const errors: Partial<Record<keyof Form, string>> = {};
  const html = /[<>]/;
  if (form.name.length > LIMITS.name) errors.name = `Máximo ${LIMITS.name} caracteres.`;
  if (form.text.length > LIMITS.text) errors.text = `Máximo ${LIMITS.text} caracteres.`;
  if (form.callToAction.length > LIMITS.callToAction) errors.callToAction = `Máximo ${LIMITS.callToAction} caracteres.`;
  for (const key of ['name', 'text', 'callToAction'] as const) {
    if (html.test(form[key])) errors[key] = 'Sin HTML: quita los caracteres < y >.';
  }
  if (form.link.trim() && !/^https?:\/\/[^\s/$.?#].[^\s]*$/i.test(form.link.trim())) {
    errors.link = 'El enlace debe empezar con https:// o http://.';
  }
  return errors;
}

